import { memo } from 'react';
import { TableProps } from '../..';
import { AuthorizeView } from 'components/Authorize';
import * as Styles from '../../styles';

interface HeaderProps {
  headers: TableProps['headers'];
  sizes: string;
}

const HeaderComponent: React.FC<HeaderProps> = ({ headers, sizes }) => {
  return (
    <Styles.Head>
      <AuthorizeView onlyAdmin>
        <Styles.Tr sizes={sizes}>
          {headers.map(header => (
            <Styles.Th key={header}>{header}</Styles.Th>
          ))}
        </Styles.Tr>
      </AuthorizeView>
      <AuthorizeView onlyClient>
        <Styles.Tr sizes={sizes}>
          {headers.map(header => (
            <Styles.Th key={header}>{header}</Styles.Th>
          ))}
        </Styles.Tr>
      </AuthorizeView>
    </Styles.Head>
  );
};

export const Header = memo(HeaderComponent);
